// l10n status: partial
import { types as t, flow } from "mobx-state-tree"
import { PageAbstractMbx } from "./PageAbstract"
//import { TraxisModel } from "../api/TraxisModel"
import { EventDetailsMixin } from "./mixin/EventDetailsMixin"
import { rootStore } from "store/RootStore"
import { SourceTypeList } from "store/page/player/source/SourceTypeList"
import { LiveTvConfig } from "scenes/LiveTv/LiveTv"
//import { moment } from "store/util/moment"
//import { TIME_FORMAT_BACKEND } from "store/model/Time"
import { computed } from "mobx"
import { cDebug } from "utils/TestSupport"
import { l10n } from "store/lang/L10n"
import Velocity from "velocity-animate"
import { EventDetailsMode } from "@quickline/coco"
import { channelId, eventId, startTs, endTs, eventType } from "utils/EventHelpers"
import { analyticsScreen, analyticsMeta, logLevel } from "store/qlapi/LogService"

export const CALLING_CONTEXT_TYPE = {
	TvLive: "TvLive",
	Recording: "Recording",
	TvGuide: "TvGuide",
	TvInfo: "TvInfo",
	RecordingRelatedContent: "RecordingRelatedContent",
	Search: "Search",
	keepOldContext: "keepOldContext"
}

export const OverlayEventDetails = t.compose(
	"OverlayEventDetails",
	PageAbstractMbx,
	EventDetailsMixin,
	t
		.model({
			EventId: t.maybeNull(t.string)
		})
		.volatile(self => ({
			//MTVW-272
			//oEvent: new TraxisModel(),
			oEvent: null,
			isShow: false,
			type: null,
			typeData: null,
			prevId: null,
			context: CALLING_CONTEXT_TYPE.TvLive, //MTV-2940 TvLive, TvGuide, Recording, RelatedContent
			adSkipInfo: null,
			_adSkipInfoQueue: [],
			_recMarker: null,
			_markerFetched: false,
			//MTVW-490 added componentType,stackComponents
			componentType: null,
			seriesId: null,
			seriesTitle: null,
			actorName: null,
			genre: null,
			subItem: null,
			stackComponents: [],
			_isPlayerPresent: false,
			// MTVW-624: autoplay support
			autoplay: false,
			// MTVW-624: combined activityStack for related content and search
			activityStack: [],
			activityBackItem: null,
			// MTVVW-708
			playEventStarted: false,
			// MTVW-1101
			keepScreenState: false,
		}))
		.views(self => ({
			//MTVW-272
			get isReady() {
				return self.oEvent && !self.oEvent?.error ? true : false
			},
			get isPlayerPresent() {
				return self._isPlayerPresent
			},
			get isVisible() {
				return self.isMounted && self.isShow
			},
			//MTV-2940 section where the relatedContent is open
			get callingContext() {
				return self.context
			},
			get getComponentType() {
				return self.componentType
			},
			get getSeriesId() {
				return self.seriesId
			},
			get getSeriesTitle() {
				return self.seriesTitle
			},
			get getActorName() {
				return self.actorName
			},
			get getGenre() {
				return self.genre
			},
			get getSubItem() {
				return self.subItem
			},
			get event() {
				return self.oEvent /*&& !rootStore.page.Player.isInLiveTv*/ ? self.oEvent : rootStore.page.Player?.source?.Event
			},
			get isPlayButtonEnabled() {
				// MTVW-1099: check for valid self.oEvent
				if (!self.oEvent) return false
				// MTVW-1094
				if (!rootStore.channelsService?.isChannelSubscribed(channelId(self.oEvent))) return false
				// MTV-1630: No play icon for channels without replay
				// condition for "ContentPlaylist" that has been recorded from a disabled replay channel
				// Need to call CreateRollingBufferPlaylist to detect "Replay Funtion für den gewünschten Zeitraum nicht verfügbar" ??
				/* MTVW-272
				return ((page.oEvent.Data.getCurrentEventType !== "n")
					? ((((page.oEvent.Data.getCurrentEventType === "p") &&
						!page?.oEvent?.Data?.Channel?.IsOnRecordingOptinList &&
						page?.type !== SourceTypeList.ContentPlaylist)
						? false
						:
						//MTV2550
						// in this case should be "c" -> current
						// and check if is in LiveTv section and the event is Live the button it will not visible 
						(rootStore.page.Player.source.Event?.id === page.oEvent.Data?.id && rootStore.page.LiveTv.isMounted) ? false : true
					))
					: false)
					*/
				//console.debug("curType %s, type %s, srcId %s, pgId %s. recOptIn %s ", page.oEvent.getCurrentEventType, page?.type, rootStore.page.Player.source.Event?.id, page.oEvent.EventId, rootStore.channelsService.getChannel(channelId(page.oEvent)).IsOnRecordingOptinList)
				// GT12: MTVW-460, MTVW-502: Channels MS flags
				//const isReplayAllowed = rootStore.channelsService?.getChannel(channelId(self.oEvent))?.hasReplay || self.type === SourceTypeList.ContentPlaylist
				let isReplayAllowed = computed(() => self.callingContext === CALLING_CONTEXT_TYPE.Recording || rootStore.page.MsEpg?.isReplayAllowed(channelId(self.oEvent), startTs(self.oEvent), endTs(self.oEvent), self.type === SourceTypeList.ContentPlaylist)).get()
				// MTVW-508
				if (!isReplayAllowed) {
					// recording outside of replay window
					if (self.getMarker()?.isComplete) isReplayAllowed = true
				}
				return ((eventType(self.oEvent) !== "n")
					? ((((eventType(self.oEvent) === "p") &&
						// GT12
						//!channel?.IsOnRecordingOptinList && self.type !== SourceTypeList.ContentPlaylist)
						!isReplayAllowed)
						? false
						:
						// MTV-2550
						// in this case should be "c" -> current
						// and check if is in LiveTv section and the event is Live the button it will not visible 
						//(rootStore.page.Player.source.Event?.id === page.oEvent.Data?.id && rootStore.page.LiveTv.isMounted) ? false : true
						// MTVW-629: added self.context === CALLING_CONTEXT_TYPE.TvLive
						// MTVW-1099: Fix eventId
						//(rootStore.page.Player.source?.Event?.id === self.oEvent?.EventId && rootStore.page.LiveTv?.isMounted && self.context === CALLING_CONTEXT_TYPE.TvLive) ? false : true
						(eventId(rootStore.page.Player.source?.Event) === eventId(self.oEvent) && rootStore.page.LiveTv?.isMounted && self.context === CALLING_CONTEXT_TYPE.TvLive) ? false : true
					))
					: false)
			},
		}))
		.actions(self => ({
			_fetchBookmark: flow(function* () {
				console.debug("_fetchBookmark")
				// MTVW-820: workaround to suppress re-render for live streams
				if (self.type !== SourceTypeList.ChannelLive) rootStore.page.CoCoBookmarks.clearBookmark()
				//if (eventType(self.oEvent) !== "n") {
				const bm = yield rootStore.page.CoCoBookmarks.getBookmarkAsync(self.oEvent, true)
				// bookmark could be added or deleted by another client
				console.debug("event bookmark", bm, self.type)
				//}
			}),
			// MTVW-708
			setPlayEventStarted(value) {
				//console.trace("FROM setPlayEventStarted", value)
				self.playEventStarted = value
			},
			_afterCreate() {
			},
			_afterCreateAsync: flow(function* () {
			}),
			setShow(bShow = null, context = CALLING_CONTEXT_TYPE.keepOldContext) {
				if (context !== CALLING_CONTEXT_TYPE.keepOldContext) {
					self.context = context
				}

				self.isShow = bShow === null ? !self.isShow : bShow
				// MTV-1774 reset error when not showing
				if (!bShow) { /*console.debug("reset ERROR");*/
					// MTVW-847: close PiP
					if (rootStore.page.Player.playerDetailPageVo.isInPip) {
						rootStore.page.Player.playerDetailPageVo.showPiP(false)
					}
					console.debug("setShow=", bShow, self.bookmarkPollId)
					clearInterval(self.bookmarkPollId)
					rootStore.page.Player.error = null
					// MTVW-186 MTVW-178

					if (self.oEvent?.error) {
						self.prevId = null
						self.oEvent.error = null
					}
					// MTVW-808: make sure that genres and actors are loaded when switching LiveTv <-> TVGuide
					self.setGenre(null)
					self.setActorName(null)
				}
				return self
			},
			setComponentType(componentType) {
				self.componentType = componentType
				//console.debug("setComponentType", componentType)
				return self
			},
			setIsPlayerPresent(newValue) {
				self._isPlayerPresent = newValue
				return self
			},
			setTypeContentPlaylist(contentId) {
				//console.debug("setTypeContentPlaylist", contentId)
				if (contentId) {
					self.type = SourceTypeList.ContentPlaylist
					self.typeData = contentId
					// MTVW-816
					// DO NOT call _fetchBookmark, CoCo reports RuntimeError if a request is pending and 2nd request is started
					//self._fetchBookmark()
				}
				else {
					self.type = null
					self.typeData = null
				}
				return self
			},
			setCallingContext(context) {
				self.context = context
				return self
			},
			/*
			_setEvent(event) {
				self.oEvent = event
			},
			*/
			getMarker(forEvent = null) {
				// MTVW-931, finding 3: disable fetch optimization, it's also called from isPlayButtonEnabled and could
				// return a wrong marker when used in the episode carousel from a recording and after opening
				// a different episode
				self._markerFetched = false
				if (!self._markerFetched) {
					const event = forEvent ?? self.event
					self._recMarker = rootStore.page.Recordings.Manager.getMarker(eventId(event))
				}
				self._markerFetched = true
				return self._recMarker
			},
			getRecording: flow(function* (markerId) {
				const recs = rootStore.api.GetRecordings({ ...{ isRecorded: true, isPlanned: true, iLimit: 2000, isChildRecordings: true, isSortDesc: false }, ...{ Ids: markerId } })
				yield recs.fetchDataAsync()
				return recs
			}),
			// MTVW-1096, finding 2: added
			_getfullEventDetails: flow(function* (id) {
				self.oEvent = yield rootStore.page.MsEpg.getEventDetailsAsync(eventId(self.oEvent), EventDetailsMode.Full)
				// MTVW-1096: replay stream start performance improvement
				if (eventId(rootStore.page.Player.source?.Event) === eventId(self.oEvent)) {
					rootStore.page.Player.source.GetEvent = self.oEvent
				}
			}),
			_getEventDetails: flow(function* (id, analyticsSource) {
				//MTVW-272
				// avoid displaying the previous (old) content
				self.oEvent = null
				// MTVW-972: prevent re-renders for recordings by not setting self.oEvent 2 times, use variable 'eventDetails' instead
				let eventDetails = yield rootStore.page.MsEpg.getEventDetailsAsync(id, EventDetailsMode.Lite)
				let isRecording = false

				// GT12: MTVW-460, MTVW-502: Channels MS flags
				//const isReplayAllowed = rootStore.channelsService?.getChannel(channelId(eventDetails))?.hasReplay || self.type === SourceTypeList.ContentPlaylist
				const isReplayAllowed = computed(() => self.callingContext === CALLING_CONTEXT_TYPE.Recording || rootStore.page.MsEpg?.isReplayAllowed(channelId(eventDetails), startTs(eventDetails), endTs(eventDetails), self.type === SourceTypeList.ContentPlaylist)).get()
				// MTVW-508
				const marker = self.getMarker(eventDetails)
				// MTVW-913: if (!isReplayAllowed) -> if (isReplayAllowed)
				if (isReplayAllowed || marker) {
					if (marker?.isComplete) {
						const recs = yield self.getRecording(marker.id)
						// MTVW-919: added if statement
						if (recs?.DataMain?.EventId) {
							eventDetails = yield rootStore.page.MsEpg.getEventDetailsAsync(recs?.DataMain?.EventId, EventDetailsMode.Lite)
							self.prevId = recs?.DataMain?.EventId
							self.setTypeContentPlaylist(marker.id)
							isRecording = true
							//console.debug("oEventData= set marker e %o", eventDetails.event.start)
						}
					}
				}
				self.oEvent = eventDetails

				//console.debug("analyticsSource", analyticsSource)
				if (analyticsSource?.screen) rootStore.logService.analyticsScreenview(analyticsSource)
				if (!analyticsSource?.ignore) rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: analyticsScreen.programDetails, event: id, isRecording: isRecording })
				self.getAdSkipInfo()
			
				// MTVW-624: autoplay support
				if (self.autoplay) {
					// don't use yield
					/*yield*/ self.setPlayEvent()
					rootStore.page.LiveTv.memoSelectedEpg = null //MTV-3740 restore the snapshot for the channelList used in EpgChannel.js
					console.debug("autoplay isInLiveTv", rootStore.page.Player.isInLiveTv /*rootStore.page.Player.playerLiveTvVo.isPlayerActive*/)
					// MTVW-727b: use isInLiveTv
					if (!rootStore.page.Player.isInLiveTv /*rootStore.page.Player.playerLiveTvVo.isPlayerActive === false*/) {
						self.setIsPlayerPresent(true)
					}
					/*else {
						self.setShow(false)
						rootStore.page.MiniEpg.setShow(false)
						self.resetActivity()
						navigateRouteAdd(ROUTE_NAMES.LiveTv)
					}
					*/
					// MTVW-629: close overlay if liveTv
					else {
						self.setShow(false)
						setTimeout(() => {
							//window.scrollTo(0, 0)
							const elem = document.getElementById("tvLiveAndDetailsContainer")
							if (elem) elem.scrollTop = 0
						}, 100)
					}
				}
				// MTVW-1075: now load the full event from CoCo
				// MTVW-1096, finding 2: kick off _getfullEventDetails without yield to prevent delayed rendering,
				// runInAction cannot be used with mobx-state-tree
				//self.oEvent = yield rootStore.page.MsEpg.getEventDetailsAsync(eventId(self.oEvent), EventDetailsMode.Full)
				self._getfullEventDetails(eventId(self.oEvent))
			}),
			// CoCo TODO: Handling of CoCo events, not yet used
			setEpgEvent: flow(function* (event, autoplay, analyticsSource) {
				if (!event) return
				//console.trace("setEpgEventById")
				self.autoplay = autoplay
				rootStore.page.Player.source.trueReplaySession = false // reset for adSkipInfo
				const mtv1690Workaround = false
				rootStore.page.CoCoBookmarks.setIgnoreEvent(null)
				// MTVW-508: disable MTV-1690 to properly start recording or replay if the show is the same
				if (!mtv1690Workaround || (self.prevId !== event.event.id)) {
					// MTVW-820: prevent re-render if live stream
					//self.type = null
					if (self.prevId !== event.event.id) {
						rootStore.page.CoCoBookmarks.clearBookmark()
						self.type = null
					}
					self.typeData = null
					self._markerFetched = false
					self.oEvent = event
					console.debug("self.oEvent", self.oEvent)
					self.prevId = event.event.id
				}
				else self.getAdSkipInfo()
				// MTVW-816: yield would cause re-render issues
				/*yield*/ self._fetchBookmark()
				//console.debug("oEventData= markerFetched", self._markerFetched)
				//return self
			}),
			// MTVW-624: autoplay support
			//setEpgEventById(id, autoplay, analyticsSource) {
			setEpgEventById: flow(function* (id, autoplay, analyticsSource, keepScreenState = false) {
				// MTV-1690: TV Guide: Clicking on the same program entry multiple times shows the overlay only at the first click
				self.keepScreenState = keepScreenState
				if (!id) return
				/// only for test log message
				///yield rootStore.logService.logAsync(logLevel.Error, "setEpgEventById", "OverlayEventDetails", {id, autoplay})
				//console.trace("setEpgEventById")
				self.autoplay = autoplay
				rootStore.page.Player.source.trueReplaySession = false // reset for adSkipInfo
				const mtv1690Workaround = false
				rootStore.page.CoCoBookmarks.setIgnoreEvent(null)
				// MTVW-508: disable MTV-1690 to properly start recording or replay if the show is the same
				if (!mtv1690Workaround || (self.prevId !== id)) {
					// MTVW-820: prevent re-render if live stream
					//self.type = null
					if (self.prevId !== id) {
						rootStore.page.CoCoBookmarks.clearBookmark()
						self.type = null
					}
					self.typeData = null
					self._markerFetched = false
					yield self._getEventDetails(id, analyticsSource)
					self.prevId = id
					//console.debug("self.oEvent", self.oEvent)
				}
				else self.getAdSkipInfo()
				// MTVW-816: yield would cause re-render issues
				/*yield*/ self._fetchBookmark()
				//console.debug("oEventData= markerFetched", self._markerFetched)
				//return self
			}),
			//setPlayEvent(startFullScreen = false) {
			setPlayEvent: flow(function* (startFullScreen = false, selectedType = "") {
				console.debug("selectedType=", selectedType, self.type)
				// MTVW-816
				// don't reset otherwise play buttons might not be displayed
				//rootStore.page.CoCoBookmarks.ignoreBookmark(selectedType !== "b")
				if (selectedType === "b") yield self._fetchBookmark()
				let type = self.type !== null ? self.type : eventType(self.oEvent) === "c" ? SourceTypeList.ChannelLive : SourceTypeList.ChannelReplay
				console.debug("selectedType=", selectedType, type)
				// MTVW-811
				if (selectedType?.length > 0 && self.type !== SourceTypeList.ContentPlaylist || selectedType === "c") {
					type = selectedType === "c" ? SourceTypeList.ChannelLive : SourceTypeList.ChannelReplay
					self.type = type
				}
				console.debug("type=", self.type)
				const player = rootStore.page.Player
				//console.debug("player is", player, player.player.__path)
				// MTVVW-727b
				const isInLiveTv = player.isInLiveTv
				console.debug("setPlayEvent ctx %s, type %s, %s, playerLiveTvVo inPip %s, liveTv %s", self.callingContext, type, self.type, player.playerLiveTvVo.isInPip, isInLiveTv)
				//if (player.playerLiveTvVo.isPlayerActive && player.playerLiveTvVo.isInPip && self.callingContext !== CALLING_CONTEXT_TYPE.TvLive) {
				if (/*player.playerLiveTvVo.isPlayerActive &&*/ player.playerLiveTvVo.isInPip && !isInLiveTv) {
					console.debug("setPlayEvent stop TvLive")
					player.setPiPPlayer(null)
					// MTVW-795: Don't use stopInstance, otherwise player.player below will return playerLiveTvVo!
					//yield player.playerLiveTvVo.stopInstance()
					yield player.playerLiveTvVo.setRefElemContainer(null, true)
					//console.debug("setPlayEvent=", player.player, document.getElementById(player.playerDetailPageVo.idDomElement))
					self.setShow(true)
				}
				// MTVW-708:
				// MTVW-864, finding 1: prevent double metadata when clicking resume and open the same show in TvInfo
				if (self.callingContext !== CALLING_CONTEXT_TYPE.TvInfo) self.setPlayEventStarted(true)
				//MTVW-272
				//const type = self.type !== null ? self.type : self.oEvent.Data.getCurrentEventType === "c" ? SourceTypeList.ChannelLive : SourceTypeList.ChannelReplay

				if (type === SourceTypeList.ContentPlaylist) {
					yield player.player.stopInstance()
					// bookmark will be handled in _openStreamContentAsync
					yield player.setPlayContentAsync(self.typeData, self.oEvent, true)
				} else if (type === SourceTypeList.ChannelLive) {
					// MTVW-213: unpause player, otherwise it would would move to a rolling buffer.
					// The issue was caused by useEffect of scenes\Player\Player.js in the
					// statement: if (page.player.isPausedUser && (page.player.inactiveReason === null)) { page.source.setPlayPause() }
					// useEffect should be re-analyzed. Fix it here for now to minimize potential side effects.
					player.player.setIsPausedUser(false)
					rootStore.page.LiveTv.setEpgListPos(channelId(self.oEvent), LiveTvConfig.cellHeight + LiveTvConfig.cellMarginBottom)
					yield player.player.stopInstance()
					yield player.setPlayChannelLiveAsync(channelId(self.oEvent), self.oEvent, true)
				} else if (type === SourceTypeList.ChannelReplay) {
					// MTV-1607
					rootStore.channelsService.setActiveChannel(channelId(self.oEvent))

					rootStore.page.LiveTv.setEpgListPos(channelId(self.oEvent), LiveTvConfig.cellHeight + LiveTvConfig.cellMarginBottom)
					// MTVW-1101: stopInstance might be commented if click on next episode does not work
					yield player.player.stopInstance()
					// bookmark will be handled in _startReplaySession
					yield player.setPlayChannelReplayAsync(channelId(self.oEvent), startTs(self.oEvent), self.oEvent, true, true)
				}
				if (player.isPlayerOnOverlay === true && !self.keepScreenState) {
					player.player.setFullScreen(startFullScreen)
				}
				// Reset self.type which is externally set for recordings. Otherwise starting a recording and afterwards starting the
				// same show (same event id) in the TvGuide whould start with 'ContentPlaylist' but has no recordingId and therefore
				// an error would be generated
				self.type = null
				// MTVW-1001: reset after play start
				rootStore.page.CoCoBookmarks.setIgnoreEvent(null)
			}),
			setSeriesId(newValue, subItem = null) {
				self.seriesId = newValue
				self.subItem = subItem
				// MTVW-1078, item 9: handle subItem
				if (subItem) rootStore.page.Search.setSeasonSelected(subItem)
				else rootStore.page.Search.setSeasonSelected(rootStore.page.Search.ALL_SEASON_SELECTED)
				return self
			},
			setSeriesTitle(newValue, subItem = null) {
				self.seriesTitle = newValue
				self.subItem = subItem
				// MTVW-1078, item 9: handle subItem
				if (subItem) rootStore.page.Search.setSeasonSelected(subItem)
				else rootStore.page.Search.setSeasonSelected(rootStore.page.Search.ALL_SEASON_SELECTED)
				return self
			},
			setActorName(newValue, subItem = null) {
				self.actorName = newValue
				self.subItem = subItem
				// MTVW-1078, item 9: handle subItem
				if (subItem) rootStore.page.Search.setGenresSelected(subItem)
				else rootStore.page.Search.setGenresSelected(rootStore.page.Search.ALL_GENRES_SELECTED)
				return self
			},
			setGenre(newValue, subItem = null) {
				self.genre = newValue
				self.subItem = subItem
				// MTVW-1078, item 9: handle subItem
				if (subItem) rootStore.page.Search.setGenresSelected(subItem)
				else rootStore.page.Search.setGenresSelected(rootStore.page.Search.ALL_GENRES_SELECTED)
				return self
			},
			setSubItem(newValue) {
				self.subItem = newValue
				return self
			},
			// MTVW-624: combined activityStack for related content and search
			pushActivity(item) {
				const playerRect = document.getElementById("ql_player_container")?.getBoundingClientRect() ?? null
				const metaRect = document.getElementById("coverMetadataContainer")?.getBoundingClientRect() ?? null
				const navbarRect = document.getElementById("navbarContainer")?.getBoundingClientRect() ?? null
				const elem = document.getElementsByClassName("MuiDialog-container")
				// adjustment when player is active and the title is below the cover,
				// the overlay layout changes since the player is stopped
				const adjustMent = !rootStore.page.Player.playerLiveTvVo.isPlayerActive && navbarRect?.width > 800 && metaRect?.bottom > playerRect?.bottom ? metaRect?.height : 0
				//console.debug("pushActivity rPlayer %o, rMeta %o, navbar %o, top %s, adjust %s, item %o", playerRect, metaRect, navbarRect, elem[0]?.scrollTop, adjustMent, item)
				if (elem?.length > 0) item.scrollTop = elem[0].scrollTop - adjustMent
				if (item?.type === 'related') {
					// load the stack content title
					// do not add if title already exists
					const duplicate = self.activityStack.filter(i => i?.type === 'related' && i?.id === item?.id)
					console.debug("duplicate", duplicate, duplicate.length)
					if (duplicate.length === 0) {
						self.activityStack.push(item)
					}
					self.showPreviousContent = self.activityStack.filter(i => i?.type === 'related') > 0 ? true : false
				}
				else self.activityStack.push(item)
				console.debug("pushActivity activityStack", item, self.activityStack)
			},
			popActivity() {
				let result = null
				if (self.activityStack.length > 0) {
					result = self.activityStack.pop()
					// MTVW-1016 item 4, poppedFilterEventType
					rootStore.page.Search.setPoppedFilterEventType(rootStore.page.Search.FILTER_EVENT_KEEP)
				}
				console.debug("popActivity", result, self.activityStack)
				return result
			},
			resetActivity() {
				self.activityStack = []
				console.debug("resetActivity")
			},
			restoreActivity() {
				const item = self.popActivity()
				// MTVW-629: added .setComponentType('event').setShow(true, CALLING_CONTEXT_TYPE.TvGuide)
				if (item?.type === 'related') {
					// MTVW-629: setIsPlayerPresent(false) so that the BoxCover is shown
					self.setIsPlayerPresent(false)
					// setShow first so that derived 'origin' is correct
					self.setShow(true, CALLING_CONTEXT_TYPE.TvGuide)
					self.setEpgEventById(item?.id, false, {}).then(res => {
						self.setComponentType('event')
						if (item?.scrollTop) {
							const elem = document.getElementsByClassName("MuiDialog-container")
							if (elem?.length > 0) {
								console.debug("restoreActivity top", item?.scrollTop, elem)
								//https://easings.net/
								const easingOption = "easeInOutExpo"
								Velocity(elem[0], { scrollTop: item.scrollTop + "px" }, {
									duration: 1200,	// value increased from 1000 to 1200 for iPad
									easing: easingOption,
									complete: function (val) {
										//if (onComplete) onComplete()
									}
								})
							}
						}
					})
				}
				else self.setActivityBackItem(item)
				//console.debug("restoreActivity backItem", self.activityBackItem, item, item?.type)
			},
			setActivityBackItem(item) {
				//console.trace("setActivityBackItem", item)
				self.activityBackItem = item
			},

			_enqueueAdSkipInfoRequest(fn) {
				self._adSkipInfoQueue.push(fn)
				if (self._adSkipInfoQueue?.length === 1) self._dequeueAdSkipInfoRequest()
			},
			_dequeueAdSkipInfoRequest() {
				//console.debug("_dequeueAdSkipInfoRequest %s", self._adSkipInfoQueue?.length)
				if (self._adSkipInfoQueue?.length > 0) {
					const fn = self._adSkipInfoQueue[0]
					if (fn) {
						//console.debug("dayTs", moment(dayTs).toString())
						fn().then(() => {
							self._adSkipInfoQueue.shift()
							self._dequeueAdSkipInfoRequest()
						})
					}
				}
			},
			getAdSkipInfo() {
				// use queue to synchronize multiple calls (start next call when previous call has been completed)
				self._enqueueAdSkipInfoRequest(self._getAdSkipInfo)
			},
			_getAdSkipInfo: flow(function* () {
				self.adSkipInfo = null
				const event = self.event
				const source = rootStore.page.Player?.source

				cDebug("overlay _getAdSkipInfo %o, %o, %o, %o, %o, %o", self.context, event?.getCurrentEventType, source?.type, event, source?.trueReplaySession, source?.sessionAdZones)

				//console.debug("_getAdSkipInfo %o, %o, %s", source, event, event?.getCurrentEventType)
				//if (((source?.type === SourceTypeList.ChannelReplay || source?.type === SourceTypeList.ContentPlaylist) && source?.trueReplaySession)
				//	|| (self.isPlayButtonEnabled && event?.getCurrentEventType !== "c") /*|| source?.sessionAdZones?.adZones?.length > 0*/) {

				// MTVW-431: show indicator / button also in live
				//if (source.isBvChannel(channelId(event)) && (event?.getCurrentEventType === "p" || source?.trueReplaySession)) {
				// MTVW-983, MTVW-985, MTVW-986, MTVW-993
				//if (source.isBvChannel(channelId(event))) {
				if (source.hasReplayPremiumButton(channelId(event))) {
					try {
						/* MTVW-431: no exemption anymore
						const marker = self.getMarker()
						let recInfo = null
						if (marker?.isComplete) {
							const recs = yield self.getRecording(marker.id)
							//console.debug("RECORDINGS %o, %o, %o", recs, recs.DataMain.CreateTime, moment(recs.DataMain.CreateTime).utc().valueOf())
							recInfo = { recordingId: marker.id, isSeries: marker.isSeries, bookingTime: moment(recs.DataMain.CreateTime).utc().valueOf() }
						}
						// TODO: check timing issue (?) with recording Navy CIS: L.A.
						console.debug("marker %o, recInfo %o", marker, recInfo)
						*/

						/* MTVW-431: Derive information from channels MS
						const channel = rootStore.channelsService.getChannel(channelId(event))
						const result = yield rootStore.adsService.adSkipInfoAsync(channelId(event), recInfo?.recordingId, event?.AvailabilityStartDateTs, recInfo?.isSeries, recInfo?.bookingTime, moment.duration(channel.maxReplayDuration, moment.ISO_8601).valueOf(), false)
						*/
						const result = {}
						result.adSkipping = source.hasPremium(channelId(event)) ? "allowed" : "notAllowed"
						// MTVW-808: liveTv / overlay decoupling, add channelId to result
						result.channelId = channelId(event)

						// MTVW-459
						// Exemption:
						// Not subscribed to Replay Premium but the program is exempt from alternative ads
						// GT12 Channel for a user with "Replay Premium" where this content is outside the replay window or
						// is a pre-scheduled single recording. Treated like a non-GT12 channel.
						if (result?.adSkipping === "notAllowed") {
							result.adButtonTitle = l10n.featureUpsellGt12Title
							// text with newline(s)
							result.adButtonText = l10n.featureUpsellGt12Description.replaceAll("\\n", "\n")
						}
						else if (result?.adSkipping === "allowed") {
							result.adButtonTitle = null
							result.adButtonText = null
						}
						/* MTVW-431> no exepmption anymore
						if (recInfo) {
							console.debug("recinfo %o, booked %s, isSeries %s, MS: %s", recInfo, moment(recInfo.bookingTime).format(TIME_FORMAT_BACKEND), recInfo.isSeries, result.adSkipping)
						}
						if (recInfo && result?.adSkipping === "notAllowed") {
							const daysAired = moment().utc().diff(moment(event?.AvailabilityStartDate).utc(), 'days')
							const bookingBeforeAired = recInfo.bookingTime < moment(event?.AvailabilityStartDate).utc().valueOf()
							console.debug("days since aired %s, recorded before aired %s", daysAired, bookingBeforeAired)
							if (recInfo.isSeries && daysAired >= 7) {
								result.adSkipping = "unavailable"
							}
							if (!recInfo.isSeries && bookingBeforeAired) {
								result.adSkipping = "unavailable"
							}
						}
						*/
						self.adSkipInfo = result
					}
					catch (e) {
						console.error("CAUGHT in _getAdSkipInfo %", e)
						rootStore.logService.logAsync(logLevel.Error, "_getAdSkipInfo", "OverlayEventDetails", e)
						self.adSkipInfo = null
					}
				}
				else {
					self.adSkipInfo = null
				}
				//console.debug("overlay %o, %o, %o, %o, %o, %o, %o", self.context, event, event?.getCurrentEventType, source?.type, self.oEvent, source?.trueReplaySession, source?.sessionAdZones)
				//console.debug("return adSkipInfo %o", self.adSkipInfo ? self.adSkipInfo : "NO adSkipInfo")
			}),
		}))
)
